"use strict";
/**
 * @file resizableHandle.js
 * @copyright 2016 Microsoft Corporation
 */
var $dyn;
(function ($dyn) {
    /**
     * Framework base class for resizable handle
     * @internal
     */
    var resizableHandle;
    (function (resizableHandle) {
        /**
         * Add a resizable handle to an element with given direction and minimum size
         * @param addHandleElement The jquery object  to add the resizable handle to
         * @param direction The direction (side) to create the handle (n, s, e, w)
         * @param minWidth The minimum width the container can be resized to
         * @param minHeight The minimum height the container can be resized to
         * @param onResize Resize event handler. This event is triggered during the resize, on the drag of the resize handler
         */
        function _addResizableHandle(addHandleElement, direction, minWidth, minHeight, onResize) {
            var splitterObject = jQuery(addHandleElement);
            splitterObject.resizable({
                handles: direction,
                minHeight: minHeight,
                minWidth: minWidth,
                zIndex: "auto",
                // tslint:disable-next-line:object-literal-sort-keys
                resize: onResize,
            });
            // We need the raw element.
            // addHandleElement is passed as a jQuery element but we can use splitterObject for safety.
            splitterObject.children(".ui-resizable-handle").each(function (i, element) {
                element._hammer = new Hammer.Manager(element);
                element._hammer.add(new Hammer.Pan({}));
                element._hammer.on("panstart", $dyn.resizableHandle._panStart);
                element._hammer.on("panend", $dyn.resizableHandle._panEnd);
                element._hammer.on("panmove", $dyn.resizableHandle._panMove);
                if ($dyn.util.isEnhancedTabSequenceEnabled()) {
                    element.addEventListener("keydown", $dyn.resizableHandle._keydownHandler);
                    element.setAttribute("tabindex", "0");
                }
                element.setAttribute("role", "separator");
                element.setAttribute("title", $dyn.label("Shell_Splitter"));
                element.setAttribute("aria-labelledby", splitterObject.attr("id"));
            });
        }
        resizableHandle._addResizableHandle = _addResizableHandle;
        /**
         * Destroy the resizable handles associated with the jQueryObject
         * @internal
         * @param destroyHandleObject The object to destroy the handles for
         */
        function _destroyResizableHandles(destroyHandleObject) {
            var splitterObject = jQuery(destroyHandleObject);
            if (splitterObject.length > 0 && splitterObject.hasClass("ui-resizable") && splitterObject.resizable("instance")) {
                splitterObject.resizable("destroy");
            }
            splitterObject.children(".ui-resizable-handle").each(function (i, element) {
                if (element._hammer) {
                    element._hammer.off("panstart", $dyn.resizableHandle._panStart);
                    element._hammer.off("panend", $dyn.resizableHandle._panEnd);
                    element._hammer.off("panmove", $dyn.resizableHandle._panMove);
                    element._hammer.destroy();
                    delete element._hammer;
                }
                element.removeEventListener("keydown", $dyn.resizableHandle._keydownHandler);
            });
        }
        resizableHandle._destroyResizableHandles = _destroyResizableHandles;
        /**
         * Handler for the keydown event.
         * @internal
         * @param event The keydown event that happened.
         */
        function _keydownHandler(event) {
            if ($dyn.util.isShortcutKeyPressed(event, {
                keyCode: [$dyn.ui.KeyCodes.rightArrow, $dyn.ui.KeyCodes.leftArrow, $dyn.ui.KeyCodes.downArrow, $dyn.ui.KeyCodes.upArrow],
            })) {
                var deltaX = void 0;
                var deltaY = void 0;
                var control = $dyn.context(event.target && event.target.parentElement);
                if (control) {
                    var $target_1 = $(event.target);
                    var originalWidth = parseInt($dyn.value(control.LayoutWidth), 10);
                    if (isNaN(originalWidth)) {
                        originalWidth = control.element.clientWidth;
                    }
                    var originalHeight = parseInt($dyn.value(control.LayoutHeight), 10);
                    if (isNaN(originalHeight)) {
                        originalHeight = control.element.clientHeight;
                    }
                    deltaX = deltaY = 0;
                    switch (event.which || event.keyCode) {
                        case $dyn.ui.KeyCodes.leftArrow:
                            deltaX = -1;
                            break;
                        case $dyn.ui.KeyCodes.rightArrow:
                            deltaX = 1;
                            break;
                        case $dyn.ui.KeyCodes.upArrow:
                            deltaY = -1;
                            break;
                        case $dyn.ui.KeyCodes.downArrow:
                            deltaY = 1;
                            break;
                        default:
                            break;
                    }
                    if ($dyn.util.isRTLMode()) {
                        deltaX = -deltaX;
                        deltaY = -deltaY;
                    }
                    if ($target_1.hasClass("ui-resizable-e") || ($target_1.hasClass("ui-resizable-w") && originalWidth)) {
                        $dyn.setValue(control, "LayoutWidth", originalWidth + deltaX + "px");
                    }
                    if ($target_1.hasClass("ui-resizable-n") || ($target_1.hasClass("ui-resizable-s") && originalHeight)) {
                        $dyn.setValue(control, "LayoutHeight", originalHeight + deltaY + "px");
                    }
                    $dyn.microTask(function () {
                        $dyn.log.focus && $dyn.log.focus("Focus: Splitter-> return focus to the splitter");
                        $target_1.focus();
                    });
                }
            }
        }
        resizableHandle._keydownHandler = _keydownHandler;
        /**
         * Handler for the Hammer panstart event.
         * @internal
         * @param event The pan event that happened.
         */
        function _panStart(event) {
            var control = $dyn.context(event.target && event.target.parentElement);
            if (control) {
                var $target = jQuery(event.target);
                control._hammerVertical = $target.hasClass("ui-resizable-e") || $target.hasClass("ui-resizable-w");
                control._hammerHorizontal = $target.hasClass("ui-resizable-n") || $target.hasClass("ui-resizable-s");
                control._hammerOriginalWidth = parseInt($dyn.value(control.LayoutWidth), 10);
                if (isNaN(control._hammerOriginalWidth)) {
                    control._hammerOriginalWidth = control.element.clientWidth;
                }
                control._hammerOriginalHeight = parseInt($dyn.value(control.LayoutHeight), 10);
                if (isNaN(control._hammerOriginalHeight)) {
                    control._hammerOriginalHeight = control.element.clientHeight;
                }
            }
        }
        resizableHandle._panStart = _panStart;
        /**
         * Handler for the Hammer panmove event.
         * @internal
         * @param event The pan event that happened.
         */
        function _panMove(event) {
            var control = $dyn.context(event.target && event.target.parentElement);
            if (control) {
                if (control._hammerVertical && control._hammerOriginalWidth) {
                    $dyn.setValue(control, "LayoutWidth", String(control._hammerOriginalWidth + event.deltaX) + "px");
                }
                if (control._hammerHorizontal && control._hammerOriginalHeight) {
                    $dyn.setValue(control, "LayoutHeight", String(control._hammerOriginalHeight + event.deltaY) + "px");
                }
            }
        }
        resizableHandle._panMove = _panMove;
        /**
         * Handler for the Hammer panend event.
         * @internal
         * @param event The pan event that happened.
         */
        function _panEnd(event) {
            var control = $dyn.context(event.target && event.target.parentElement);
            if (control) {
                delete control._hammerOriginalWidth;
                delete control._hammerOriginalHeight;
                delete control._hammerHorizontal;
                delete control._hammerVertical;
            }
        }
        resizableHandle._panEnd = _panEnd;
    })(resizableHandle = $dyn.resizableHandle || ($dyn.resizableHandle = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=resizableHandle.js.map
